<template>
  <v-timeline-item
    dot-color="userActivity"
    icon="mdi-lead-pencil"
    fill-dot
  >
    <v-expansion-panels
      class="expansion-panels"
      variant="accordion"
      flat
    >
      <v-expansion-panel>
        <v-expansion-panel-title>
          <v-row
            no-gutters
            align="center"
            class="d-flex justify-center"
            :class="{ 'flex-column': $vuetify.display.smAndDown }"
          >
            <v-col md="8">
              <div class="mb-2 text-subtitle-1 text-truncate">
                <span class="text-wrap">{{ data.text }}</span>
              </div>
              <div class="text-grey text--small">
                {{ $t('lead-timeline.commentary.title', { userName: data.userName }) }}
              </div>
            </v-col>
            <v-col
              class="pr-2 text-right text-grey text--small"
              :class="{ 'text-start mt-2': $vuetify.display.smAndDown }"
              md="4"
            >
              {{ formatDate(data.createdAt) }}
            </v-col>
          </v-row>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row>
            <v-col md="12">
              <v-list density="compact">
                <v-list-item class="px-0">
                  <v-textarea
                    class="mr-6"
                    variant="outlined"
                    disabled
                    hide-details
                    auto-grow
                    :model-value="data.text"
                  />

                  <v-dialog
                    v-model="dialog"
                    width="350"
                  >
                    <template v-slot:activator="{ props }">
                      <div class="justify-end pt-1 pr-8 d-flex">
                        <span
                          class="text-error text-body-2"
                          style="cursor: pointer; text-decoration: underline"
                          v-bind="props"
                        >
                          {{ $t('labels.delete') }}
                        </span>
                      </div>
                    </template>

                    <v-card>
                      <v-card-title class="pa-0">
                        <v-toolbar
                          color="primary"
                          dark
                          flat
                        >
                          <v-toolbar-title>{{
                            $t('lead-timeline.commentary.dialog.title')
                          }}</v-toolbar-title>
                          <v-spacer />
                          <v-toolbar-items>
                            <!-- TODO: check unsupported prop dark -->
                            <v-btn
                              icon
                              @click="dialog = false"
                            >
                              <v-icon size="large"> mdi-close </v-icon>
                            </v-btn>
                          </v-toolbar-items>
                        </v-toolbar>
                      </v-card-title>

                      <v-card-text class="mt-4">
                        <span>
                          {{ $t('lead-timeline.commentary.dialog.subtitle') }}
                        </span>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />

                        <v-btn
                          variant="text"
                          @click="dialog = false"
                        >
                          {{ $t('labels.cancel') }}
                        </v-btn>

                        <v-btn
                          color="error"
                          variant="text"
                          @click="deleteCommentary"
                        >
                          {{ $t('labels.confirm') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-timeline-item>
</template>

<script>
import bus, { eventNames } from '@/lib/eventBus'

import DELETE_COMMENTARY from '../queries/DeleteCommentary.gql'
import LEAD from '../queries/Lead.gql'

export default {
  props: {
    data: { type: Object, default: null },
    leadId: { type: String, default: null },
  },
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    async deleteCommentary() {
      try {
        const { data } = await this.$apollo.mutate({
          mutation: DELETE_COMMENTARY,
          variables: {
            leadId: this.leadId,
            commentaryId: this.data.id,
          },
          refetchQueries: [{ query: LEAD, variables: { id: this.leadId } }],
        })

        if (data.response) this.dialog = false

        bus.$emit(eventNames.SHOW_SNACKBAR, {
          color: 'success',
          text: this.$t('alerts.lead.commentary.success-delete'),
        })
      } catch (e) {
        bus.$emit(eventNames.SHOW_SNACKBAR, {
          color: 'error',
          text: this.$t('alerts.lead.commentary.error-delete'),
        })
      }
    },
  },
}
</script>

<style scoped>
.expansion-panels {
  margin: -24px -24px 0 -24px;
}
</style>
